import { makeStyles } from '@mui/styles';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import { SidebarProps } from '.';

export const muiStyles = makeStyles((theme: ApplicationMuiTheme) => {
    const isGlobalHeaderEnabled = (props: SidebarProps) => (props.admin && theme?.app?.clientTheme.layoutSettings.useGlobalHeader) ||
        (!props.admin && theme?.app?.clientTheme.layoutSettings.useClientGlobalHeader);

    return {
        logo: {
            minHeight: '90px',
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: props => (isGlobalHeaderEnabled(props as SidebarProps) ?
                '#000'
                : theme?.app?.applicationColors.backgroundAccented || '#D7DBE4')
        },
        logoImg: {
            height: props => (isGlobalHeaderEnabled(props as SidebarProps) ? '45px' : '66px'),
            width: props => (isGlobalHeaderEnabled(props as SidebarProps) ? '55px' : '76px')
        },
        outerContainer: {
            height: '100%',
            backgroundColor: theme?.app?.clientTheme.colors.sidebar?.backgroundColor ||
                '#000',
            overflow: 'hidden'
        },
        container: {
            display: 'flex',
            flexDirection: 'column' as const,
            listStyleType: 'none' as const,
            margin: 0,
            padding: 0,
            width: '100%'
        },
        userAvatar: {
            height: '40px',
            width: '40px',
            fontSize: '1rem',
            color: 'white',
            backgroundColor: theme?.app?.clientTheme.colors.primaryColorDark ||
                '#0A2240'
        },
        userMenu: { cursor: 'pointer' },
        menuLink: {
            color: theme?.app?.applicationColors.fontColor ||
                '#202020',
            textDecoration: 'none' as const
        },
        divider: {
            backgroundColor: '#888',
            marginBottom: '1.5rem'
        }
    };
});